import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        accessUntil: '=',
        uibModalInstance: '='
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'planning.employee.Change access dates for selected employees' | translate }}</h2>
        </div>
            <div class="modal-body">
                <div class="form">
                    <div class="row">
                        <span class="label">{{ 'planning.employee.Access until' | translate }}</span>
                        <div class="items">
                        <datetimepicker ng-model="vm.accessUntil"
                                        class="ng-pristine ng-untouched ng-valid ng-isolate-scope ng-empty"
                        >
                        </datetimepicker>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.close()">
                        {{ 'general.Add' | translate }}
                    </button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()">
                        {{ 'general.Cancel' | translate }}
                    </button>
                </li>
            </ul>
        </div>
    `
})

export default class {

    close () {
        this.uibModalInstance.close(this.accessUntil);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/planning/changeAccessUntil/index.js